// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/Montserrat-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/Poppins-Regular.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hidden {
  display: none;
}
@font-face {
  font-family: "Montserrat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff");
}
@font-face {
  font-family: "Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
}
.main-404 {
  text-align: center;
  padding: 5rem;
  color: #333;
}
.main-404 a {
  color: #0073aa;
  text-decoration: underline;
}
.main-404 a:hover {
  color: #005177;
}
.mobile-menu {
  display: none;
  grid-template-rows: auto;
  background: #ffffff;
  padding: 1rem;
}
.mobile-menu ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.mobile-menu li {
  text-transform: uppercase;
  margin: 0;
}
.mobile-menu li a {
  text-decoration: none;
  color: inherit;
  display: block;
  padding: 0.5rem 1rem;
}
.mobile-menu li:hover {
  background-color: rgba(6, 147, 227, 0.5);
}
.mobile-menu .social-links {
  display: flex;
}
.mobile-menu .social-links a {
  text-decoration: none;
  color: inherit;
  display: block;
  padding: 0.5rem 1rem;
}
.mobile-menu .phone {
  text-decoration: none;
  color: inherit;
  display: block;
  padding: 0.5rem 1rem;
}
.mobile-menu .sub-menu {
  display: none;
  flex-direction: column;
  padding-left: 0;
}
.mobile-menu .sub-menu ul {
  list-style: none;
  margin: 0;
  padding: 0;
  align-items: center;
}
.mobile-menu .sub-menu li a {
  padding: 0.5rem 1rem;
}
@media (min-width: 768px) {
  .mobile-menu {
    display: none !important;
  }
}
@media (min-width: 1024px) {
  .site-header {
    display: flex;
    justify-content: center;
  }
}
.site-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 4rem;
}
.site-nav > * {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.site-nav button,
.site-nav a {
  height: 100%;
  padding: 0 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  outline: none;
  box-shadow: none;
  font: inherit;
  color: inherit;
  cursor: pointer;
}
.site-nav * svg,
.site-nav * img {
  font-size: 2rem;
  max-height: 100%;
  width: auto;
}
@media (min-width: 1024px) {
  .site-nav .hamburger {
    display: none;
  }
}
.nav-items {
  display: none;
}
.nav-items > ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0;
}
.nav-items li {
  text-transform: uppercase;
}
.nav-items li a {
  text-decoration: none;
  color: inherit;
  display: block;
  padding: 0.5rem 1rem;
}
.nav-items .has-sub-menu {
  position: relative;
}
.nav-items .has-sub-menu .sub-menu {
  display: none;
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  flex-direction: column;
  background: #ffffff;
  padding: 0.5rem 0;
  border: solid 1px;
}
.nav-items .has-sub-menu .sub-menu ul {
  display: flex;
  flex-direction: column;
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 0;
}
.nav-items .has-sub-menu .sub-menu ul li:hover {
  background-color: rgba(6, 147, 227, 0.5);
}
.nav-items .has-sub-menu li {
  text-transform: uppercase;
  list-style: none;
}
.nav-items .has-sub-menu li a {
  text-decoration: none;
  padding: 0.5rem 1rem;
  display: block;
  color: inherit;
}
.nav-items .has-sub-menu:hover .sub-menu {
  display: flex;
}
@media (min-width: 1024px) {
  .nav-items {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1rem;
  }
}
@media (min-width: 1024px) {
  .nav-items {
    display: flex;
    flex: 1;
  }
  .nav-items > ul {
    flex-direction: row;
    gap: 1rem;
  }
}
#site-footer {
  background: #000000;
  color: #ffffff;
  padding: 3rem 2rem;
  text-align: center;
}
#site-footer .footer-columns {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 2rem;
  margin-bottom: 2.5rem;
}
#site-footer .footer-columns > * {
  flex: 1 1 150px;
  list-style: none;
  text-decoration: none;
  text-align: left;
}
#site-footer .footer-columns > * .title {
  text-transform: uppercase;
  font-weight: 600;
  margin-bottom: 0.75rem;
  color: #ffffff;
}
#site-footer .footer-columns > * ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
#site-footer .footer-columns > * ul li {
  margin-bottom: 0.4rem;
}
#site-footer .footer-columns > * ul li a {
  color: #f5f9fc;
  text-decoration: none;
  transition: color 0.3s ease;
}
#site-footer .footer-columns > * ul li a:hover {
  color: #ffffff;
}
#site-footer .footer-social {
  margin: 2rem 0 1rem;
}
#site-footer .footer-social a {
  color: #ffffff;
  font-size: 1.3rem;
  margin: 0 0.6rem;
  transition: opacity 0.3s ease;
}
#site-footer .footer-social a:hover {
  opacity: 0.7;
}
#site-footer .footer-phone {
  display: block;
  color: #ffffff;
  font-weight: 600;
  margin-bottom: 1.5rem;
  text-decoration: none;
}
#site-footer .footer-bottom {
  font-size: 0.85rem;
  opacity: 0.75;
}
@media (max-width: 768px) {
  #site-footer .footer-columns {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  #site-footer .footer-columns > * {
    flex: none;
    width: 100%;
  }
}
#site-footer::before {
  content: "";
  position: absolute;
  inset: 0;
  background: var(--footer-overlay) center / cover no-repeat;
  opacity: 0.2;
  z-index: 0;
  pointer-events: none;
}
#site-footer .footer-content {
  position: relative;
  z-index: 1;
}
.hero {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000000;
  color: #ffffff !important;
  height: 100vh;
}
.hero .hero-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-transform: uppercase;
}
.hero .hero-container .hero-buttons {
  display: flex;
}
.hero .hero-container .hero-buttons a {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.features {
  display: flex;
  justify-content: center;
}
.features .features-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 4rem;
  text-align: center;
}
@media (min-width: 1024px) {
  .features .features-container {
    width: 750px;
  }
}
.features .features-container .feature-columns {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
}
@media (min-width: 1024px) {
  .features .features-container .feature-columns {
    display: flex;
    flex-direction: row;
  }
}
.features .features-container .feature-columns .feature {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 2rem;
}
.features .features-container .feature-columns .feature h3 {
  color: #0693e3;
}
.features .features-container .feature-columns .feature * {
  margin: 1.5rem;
}
.features .features-container .feature-columns .feature svg {
  font-size: 4rem;
  color: #0693e3;
}
.features .features-container .feature-columns .feature a {
  text-decoration: none;
  border: solid 1px #0693e3;
  padding: 1rem;
  color: #0693e3;
  border-radius: 0.5rem;
}
.features .features-container .feature-columns .feature a:hover {
  background-color: #0693e3;
  border: solid 1px #ffffff;
  color: #ffffff;
}
.cta {
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: #0693e3;
  height: 100vh;
  padding: 2rem;
}
.cta .cta-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
@media (min-width: 1024px) {
  .cta .cta-container {
    display: flex;
    flex-direction: row;
  }
}
.cta .cta-container .cta-image {
  margin: 4rem;
}
.cta .cta-container .cta-image svg {
  font-size: 10rem;
}
@media (min-width: 768px) {
  .cta .cta-container .cta-image svg {
    font-size: 20rem;
  }
}
.cta .cta-container .cta-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.cta .cta-container .cta-content a {
  text-align: center;
}
@media (min-width: 1024px) {
  .cta .cta-container .cta-content {
    width: 750px;
  }
}
body {
  background-color: #f5f9fc;
  color: #000000;
}
body {
  margin: 0 auto;
  max-width: 100%;
  background: #ffffff;
  color: #000000;
  line-height: 1.6;
  font-family: system-ui, sans-serif;
}
.button-primary {
  background: #000000;
  color: #0693e3;
  border: solid 1px #0693e3;
  padding: 1rem;
  margin: 0.5rem;
  text-decoration: none;
  text-transform: uppercase;
  border-radius: 0.5rem;
}
.button-primary:hover {
  background-color: #0693e3;
  color: #000000;
  border: solid 1px #000000;
}
.button-secondary {
  background: #000000;
  color: #ffffff;
  border: solid 1px #ffffff;
  padding: 1rem;
  margin: 0.5rem;
  text-decoration: none;
  text-transform: uppercase;
  border-radius: 0.5rem;
}
.button-secondary:hover {
  background-color: #0693e3;
  color: #000000;
  border: solid 1px #000000;
}
body {
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  color: #000000;
  line-height: 1.6;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  letter-spacing: 0.5px;
  margin: 0 0 1rem;
}
.page {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
  padding: 2rem;
}
.font-demo {
  border: 1px solid #ffffff;
  border-radius: 8px;
  padding: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/styles/variables.less","webpack://./src/styles/index.less","webpack://./src/styles/fonts.less","webpack://./src/styles/404.less","webpack://./src/styles/header/mobile-menu.less","webpack://./src/styles/header/nav.less","webpack://./src/styles/footer/footer-main.less","webpack://./src/styles/front-page/hero-section.less","webpack://./src/styles/front-page/features-section.less","webpack://./src/styles/front-page/cta-section.less"],"names":[],"mappings":"AAsBA;EACE,aAAA;ACrBF;ACFA;EACE,yBAAA;EACA,2DAAA;ADIF;ACDA;EACE,sBAAA;EACA,2DAAA;ADGF;AEVA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;AFYF;AEfA;EAMI,cAAA;EACA,0BAAA;AFYJ;AEXI;EACE,cAAA;AFaN;AGtBA;EACE,aAAA;EACA,wBAAA;EACA,mBAAA;EACA,aAAA;AHwBF;AG5BA;EAOI,gBAAA;EACA,SAAA;EACA,UAAA;AHwBJ;AGjCA;EAaI,yBAAA;EACA,SAAA;AHuBJ;AGrCA;EAiBM,qBAAA;EACA,cAAA;EACA,cAAA;EACA,oBAAA;AHuBN;AGpBI;EACE,wCAAA;AHsBN;AG9CA;EA6BI,aAAA;AHoBJ;AGjDA;EA+BM,qBAAA;EACA,cAAA;EACA,cAAA;EACA,oBAAA;AHqBN;AGvDA;EAuCI,qBAAA;EACA,cAAA;EACA,cAAA;EACA,oBAAA;AHmBJ;AG7DA;EA8CI,aAAA;EACA,sBAAA;EACA,eAAA;AHkBJ;AGlEA;EAmDM,gBAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;AHkBN;AGxEA;EA0DM,oBAAA;AHiBN;AGZA;EACE;IACE,wBAAA;EHcF;AACF;AI7EE;EAAA;IACE,aAAA;IACA,uBAAA;EJgFF;AACF;AI7EA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;AJ+EF;AInFA;EAOI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AJ+EJ;AIzFA;;EAeI,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;AJ6EJ;AIxGA;;EAgCI,eAAA;EACA,gBAAA;EACA,WAAA;AJ4EJ;AIzEE;EAAA;IAEI,aAAA;EJ2EJ;AACF;AIvEA;EACE,aAAA;AJyEF;AI1EA;EAII,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,MAAA;AJyEJ;AIlFA;EAaI,yBAAA;AJwEJ;AIrFA;EAeM,qBAAA;EACA,cAAA;EACA,cAAA;EACA,oBAAA;AJyEN;AI3FA;EAuBI,kBAAA;AJuEJ;AI9FA;EA0BM,aAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;AJuEN;AIzGA;EAqCQ,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;AJuER;AIjHA;EA4CU,wCAAA;AJwEV;AIpHA;EAkDM,yBAAA;EACA,gBAAA;AJqEN;AIxHA;EAqDQ,qBAAA;EACA,oBAAA;EACA,cAAA;EACA,cAAA;AJsER;AIlEI;EACE,aAAA;AJoEN;AIhEE;EAAA;IACE,aAAA;IACA,mBAAA;IACA,mBAAA;IACA,SAAA;EJmEF;AACF;AIhEA;EACE;IACE,aAAA;IACA,OAAA;EJkEF;EIpEA;IAII,mBAAA;IACA,SAAA;EJmEJ;AACF;AKtMA;EACE,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;ALwMF;AK5MA;EAOI,aAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;EACA,qBAAA;ALwMJ;AKnNA;EAcM,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;ALwMN;AKzNA;EAoBQ,yBAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;ALwMR;AK/NA;EA2BQ,SAAA;EACA,UAAA;EACA,gBAAA;ALuMR;AKpOA;EAgCU,qBAAA;ALuMV;AKvOA;EAmCY,cAAA;EACA,qBAAA;EACA,2BAAA;ALuMZ;AKrMY;EACE,cAAA;ALuMd;AK/OA;EAiDI,mBAAA;ALiMJ;AKlPA;EAoDM,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,6BAAA;ALiMN;AK/LM;EACE,YAAA;ALiMR;AK3PA;EAgEI,cAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,qBAAA;AL8LJ;AKlQA;EAwEI,kBAAA;EACA,aAAA;AL6LJ;AKzLE;EAAA;IAEI,sBAAA;IACA,mBAAA;IACA,kBAAA;EL2LJ;EK/LA;IAOM,UAAA;IACA,WAAA;EL2LN;AACF;AKvLE;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,0DAAA;EACA,YAAA;EACA,UAAA;EACA,oBAAA;ALyLJ;AK1RA;EAqGI,kBAAA;EACA,UAAA;ALwLJ;AM9RA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,aAAA;ANgSF;AMtSA;EAQI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;ANiSJ;AM5SA;EAaM,aAAA;ANkSN;AM/SA;EAeQ,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;ANmSR;AOvTA;EACE,aAAA;EACA,uBAAA;APyTF;AO3TA;EAII,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AP0TJ;AOzTI;EAAA;IACE,YAAA;EP4TJ;AACF;AOxUA;EAcM,aAAA;EACA,8BAAA;EACA,sBAAA;EACA,mBAAA;AP6TN;AO5TM;EAAA;IACE,aAAA;IACA,mBAAA;EP+TN;AACF;AOpVA;EAuBQ,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;APgUR;AO3VA;EA6BU,cAAA;APiUV;AO9VA;EAgCU,cAAA;APiUV;AOjWA;EAmCU,eAAA;EACA,cAAA;APiUV;AOrWA;EAuCU,qBAAA;EACA,yBAAA;EACA,aAAA;EACA,cAAA;EACA,qBAAA;APiUV;AOhUU;EACE,yBAAA;EACA,yBAAA;EACA,cAAA;APkUZ;AQjXA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBAAA;EACA,aAAA;EACA,aAAA;ARmXF;AQzXA;EAQI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;ARoXJ;AQnXI;EAAA;IACE,aAAA;IACA,mBAAA;ERsXJ;AACF;AQrYA;EAiBM,YAAA;ARuXN;AQxYA;EAmBQ,gBAAA;ARwXR;AQvXQ;EAAA;IACE,gBAAA;ER0XR;AACF;AQhZA;EA0BM,aAAA;EACA,sBAAA;EACA,uBAAA;ARyXN;AQrZA;EA8BQ,kBAAA;AR0XR;AQxXM;EAAA;IACE,YAAA;ER2XN;AACF;AApZA;EACE,yBAAA;EACA,cAAA;AAsZF;AAnZA;EACE,cAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,kCAAA;AAqZF;AAlZA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,aAAA;EACA,cAAA;EACA,qBAAA;EACA,yBAAA;EACA,qBAAA;AAoZF;AAnZE;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AAqZJ;AAjZA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,aAAA;EACA,cAAA;EACA,qBAAA;EACA,yBAAA;EACA,qBAAA;AAmZF;AAlZE;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AAoZJ;AAhZA;EACE,kCAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAkZF;AA/YA;;;;;;EAME,qCAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;AAiZF;AA9YA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,aAAA;AAgZF;AA7YA;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;AA+YF","sourcesContent":["// Responsive Behavior\n@screen-sm: ~\"(min-width: 640px)\";\n@screen-md: ~\"(min-width: 768px)\";\n@screen-lg: ~\"(min-width: 1024px)\";\n@screen-xl: ~\"(min-width: 1280px)\";\n@screen-2xl: ~\"(min-width: 1536px)\";\n\n// Numeric versions for max-width calculations\n@screen-sm-px: 640;\n@screen-md-px: 768;\n@screen-lg-px: 1024;\n@screen-xl-px: 1280;\n@screen-2xl-px: 1536;\n\n// Max-width queries (computed)\n@screen-max-sm: ~\"@{screen-sm-px - 1}px\";\n@screen-max-md: ~\"@{screen-md-px - 1}px\";\n@screen-max-lg: ~\"@{screen-lg-px - 1}px\";\n@screen-max-xl: ~\"@{screen-xl-px - 1}px\";\n@screen-max-2xl: ~\"@{screen-2xl-px - 1}px\";\n\n// Hidden elements\n.hidden {\n  display: none;\n}\n\n// Core colors\n@white: #ffffff;\n@black: #000000;\n\n// Primary accent\n@primary: #0693e3;\n\n// Secondary accent\n@secondary: #00d084;\n\n// Neutral / background\n@gray-light: #abb8c3;\n@gray-pale: #f5f9fc;\n\n@gradient-primary: linear-gradient(135deg, @primary 0%, #9b51e0 100%);\n@gradient-accent: linear-gradient(135deg, @secondary 0%, #7bdcb5 100%);\n\n// Font families\n@font-heading: \"Montserrat\", sans-serif;\n@font-body: \"Poppins\", sans-serif;\n\n// Alternate pair (flipped)\n@font-heading-alt: \"Poppins\", sans-serif;\n@font-body-alt: \"Montserrat\", sans-serif;\n","@import \"variables.less\";\n@import \"fonts.less\";\n@import \"404.less\";\n@import \"header/nav.less\";\n@import \"footer/footer-main.less\";\n@import \"front-page/hero-section.less\";\n@import \"front-page/features-section.less\";\n@import \"front-page/cta-section.less\";\n\nbody {\n  background-color: @gray-pale;\n  color: @black;\n}\n\nbody {\n  margin: 0 auto;\n  max-width: 100%;\n  background: @white;\n  color: @black;\n  line-height: 1.6;\n  font-family: system-ui, sans-serif;\n}\n\n.button-primary {\n  background: @black;\n  color: @primary;\n  border: solid 1px @primary;\n  padding: 1rem;\n  margin: 0.5rem;\n  text-decoration: none;\n  text-transform: uppercase;\n  border-radius: 0.5rem;\n  &:hover {\n    background-color: @primary;\n    color: @black;\n    border: solid 1px @black;\n  }\n}\n\n.button-secondary {\n  background: @black;\n  color: @white;\n  border: solid 1px @white;\n  padding: 1rem;\n  margin: 0.5rem;\n  text-decoration: none;\n  text-transform: uppercase;\n  border-radius: 0.5rem;\n  &:hover {\n    background-color: @primary;\n    color: @black;\n    border: solid 1px @black;\n  }\n}\n\nbody {\n  font-family: @font-body;\n  font-weight: 400;\n  color: @black;\n  line-height: 1.6;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: @font-heading;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  margin: 0 0 1rem;\n}\n\n.page {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 2rem;\n  padding: 2rem;\n}\n\n.font-demo {\n  border: 1px solid @white;\n  border-radius: 8px;\n  padding: 1rem;\n}\n","@font-face {\n  font-family: \"Montserrat\";\n  src: url(\"../assets/fonts/Montserrat-Regular.woff\") format(\"woff\");\n}\n\n@font-face {\n  font-family: \"Poppins\";\n  src: url(\"../assets/fonts/Poppins-Regular.woff\") format(\"woff\");\n}\n",".main-404 {\n  text-align: center;\n  padding: 5rem;\n  color: #333;\n\n  a {\n    color: #0073aa;\n    text-decoration: underline;\n    &:hover {\n      color: darken(#0073aa, 10%);\n    }\n  }\n}\n",".mobile-menu {\n  display: none;\n  grid-template-rows: auto;\n  background: @white;\n  padding: 1rem;\n\n  ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n  }\n\n  li {\n    text-transform: uppercase;\n    margin: 0;\n\n    a {\n      text-decoration: none;\n      color: inherit;\n      display: block;\n      padding: 0.5rem 1rem;\n    }\n\n    &:hover {\n      background-color: fade(@primary, 50%);\n    }\n  }\n\n  .social-links {\n    display: flex;\n    a {\n      text-decoration: none;\n      color: inherit;\n      display: block;\n      padding: 0.5rem 1rem;\n    }\n  }\n\n  .phone {\n    text-decoration: none;\n    color: inherit;\n    display: block;\n    padding: 0.5rem 1rem;\n  }\n\n  .sub-menu {\n    display: none;\n    flex-direction: column;\n    padding-left: 0;\n\n    ul {\n      list-style: none;\n      margin: 0;\n      padding: 0;\n      align-items: center;\n    }\n\n    li a {\n      padding: 0.5rem 1rem;\n    }\n  }\n}\n\n@media @screen-md {\n  .mobile-menu {\n    display: none !important;\n  }\n}\n","@import \"./mobile-menu.less\";\n\n.site-header {\n  @media @screen-lg {\n    display: flex;\n    justify-content: center;\n  }\n}\n\n.site-nav {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 4rem;\n\n  > * {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n  }\n\n  button,\n  a {\n    height: 100%;\n    padding: 0 1rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    background: none;\n    border: none;\n    outline: none;\n    box-shadow: none;\n    font: inherit;\n    color: inherit;\n    cursor: pointer;\n  }\n\n  * svg,\n  * img {\n    font-size: 2rem;\n    max-height: 100%;\n    width: auto;\n  }\n\n  @media @screen-lg {\n    .hamburger {\n      display: none;\n    }\n  }\n}\n\n.nav-items {\n  display: none;\n\n  > ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n  }\n\n  li {\n    text-transform: uppercase;\n    a {\n      text-decoration: none;\n      color: inherit;\n      display: block;\n      padding: 0.5rem 1rem;\n    }\n  }\n\n  .has-sub-menu {\n    position: relative;\n\n    .sub-menu {\n      display: none;\n      position: absolute;\n      top: 100%;\n      left: 50%;\n      transform: translateX(-50%);\n      flex-direction: column;\n      background: @white;\n      padding: 0.5rem 0;\n      border: solid 1px;\n\n      ul {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        list-style: none;\n        margin: 0;\n        padding: 0;\n        li:hover {\n          background-color: fade(@primary, 50%);\n        }\n      }\n    }\n\n    li {\n      text-transform: uppercase;\n      list-style: none;\n      a {\n        text-decoration: none;\n        padding: 0.5rem 1rem;\n        display: block;\n        color: inherit;\n      }\n    }\n\n    &:hover .sub-menu {\n      display: flex;\n    }\n  }\n\n  @media @screen-lg {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 1rem;\n  }\n}\n\n@media @screen-lg {\n  .nav-items {\n    display: flex;\n    flex: 1;\n    > ul {\n      flex-direction: row;\n      gap: 1rem;\n    }\n  }\n}\n","@import \"../variables.less\";\n\n#site-footer {\n  background: darken(@primary, 50%);\n  color: @white;\n  padding: 3rem 2rem;\n  text-align: center;\n\n  .footer-columns {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 2rem;\n    margin-bottom: 2.5rem;\n\n    > * {\n      flex: 1 1 150px;\n      list-style: none;\n      text-decoration: none;\n      text-align: left;\n\n      .title {\n        text-transform: uppercase;\n        font-weight: 600;\n        margin-bottom: 0.75rem;\n        color: @white;\n      }\n\n      ul {\n        margin: 0;\n        padding: 0;\n        list-style: none;\n\n        li {\n          margin-bottom: 0.4rem;\n\n          a {\n            color: @gray-pale;\n            text-decoration: none;\n            transition: color 0.3s ease;\n\n            &:hover {\n              color: @white;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .footer-social {\n    margin: 2rem 0 1rem;\n\n    a {\n      color: @white;\n      font-size: 1.3rem;\n      margin: 0 0.6rem;\n      transition: opacity 0.3s ease;\n\n      &:hover {\n        opacity: 0.7;\n      }\n    }\n  }\n\n  .footer-phone {\n    display: block;\n    color: @white;\n    font-weight: 600;\n    margin-bottom: 1.5rem;\n    text-decoration: none;\n  }\n\n  .footer-bottom {\n    font-size: 0.85rem;\n    opacity: 0.75;\n  }\n\n  // Mobile adjustments\n  @media (max-width: 768px) {\n    .footer-columns {\n      flex-direction: column;\n      align-items: center;\n      text-align: center;\n\n      > * {\n        flex: none;\n        width: 100%;\n      }\n    }\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    inset: 0;\n    background: var(--footer-overlay) center/cover no-repeat;\n    opacity: 0.2;\n    z-index: 0;\n    pointer-events: none;\n  }\n\n  .footer-content {\n    position: relative;\n    z-index: 1;\n  }\n}\n","@import \"../variables.less\";\n\n.hero {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: darken(@primary, 50%);\n  color: @white !important;\n  height: 100vh;\n  .hero-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-transform: uppercase;\n    .hero-buttons {\n      display: flex;\n      a {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        text-align: center;\n      }\n    }\n  }\n}\n",".features {\n  display: flex;\n  justify-content: center;\n  .features-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 4rem;\n    text-align: center;\n    @media @screen-lg {\n      width: 750px;\n    }\n    .feature-columns {\n      display: flex;\n      justify-content: space-between;\n      flex-direction: column;\n      align-items: center;\n      @media @screen-lg {\n        display: flex;\n        flex-direction: row;\n      }\n      .feature {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        margin: 2rem;\n        h3 {\n          color: @primary;\n        }\n        * {\n          margin: 1.5rem;\n        }\n        svg {\n          font-size: 4rem;\n          color: @primary;\n        }\n        a {\n          text-decoration: none;\n          border: solid 1px @primary;\n          padding: 1rem;\n          color: @primary;\n          border-radius: 0.5rem;\n          &:hover {\n            background-color: @primary;\n            border: solid 1px @white;\n            color: @white;\n          }\n        }\n      }\n    }\n  }\n}\n",".cta {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  background-color: @primary;\n  height: 100vh;\n  padding: 2rem;\n  .cta-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    @media @screen-lg {\n      display: flex;\n      flex-direction: row;\n    }\n    .cta-image {\n      margin: 4rem;\n      svg {\n        font-size: 10rem;\n        @media @screen-md {\n          font-size: 20rem;\n        }\n      }\n    }\n    .cta-content {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      a {\n        text-align: center;\n      }\n      @media @screen-lg {\n        width: 750px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
